import React, { useState } from "react";
import Skill from "./Skill";
import Details from "./Details";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

function Project({ item, index }) {
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(false);
  };
  const [proj, projInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <motion.div
      className="project"
      ref={proj}
      initial="hidden"
      animate={projInView ? "visible" : "hidden"}
      variants={animationVariants}
    >
      <img
        src={require(`../assets/${item.image[0]}`)}
        alt=""
        onClick={() => setClicked(true)}
      />
      <div className="project-title" onClick={() => setClicked(true)}>
        {item.title}
      </div>
      <div className="skills">
        {item.skills.map((item, index) => (
          <Skill key={index} name={item} />
        ))}
      </div>
      <Details clicked={clicked} handleClick={handleClick} item={item} />
    </motion.div>
  );
}

export default Project;
